import { MicrophoneIcon } from "@heroicons/react/24/outline";
import CustomAudioPlayer from "./CustomAudioPlayer";

const VoiceRecordingsList = ({ recordings, onDeleteRecording }) => {
  if (recordings.length === 0) return null

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
        Voice Recordings ({recordings.length})
      </label>
      <div className="space-y-2 max-h-64 overflow-y-auto border border-gray-200 dark:border-gray-700 rounded-lg p-2">
        {recordings.map((audio) => (
          <div
            key={audio.id}
            className={`bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden ${audio.isUploading ? 'opacity-60' : ''}`}
          >
            <div className="flex items-center gap-3 p-3">
              {/* Microphone Icon */}
              <div className="w-10 h-10 flex items-center justify-center bg-red-50 dark:bg-red-900/20 rounded-full flex-shrink-0 relative">
                <MicrophoneIcon className="w-5 h-5 text-red-600 dark:text-red-400" />
                {audio.isUploading && (
                  <div className="absolute inset-0 flex items-center justify-center bg-black/50 rounded-full">
                    <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  </div>
                )}
              </div>

              {/* Audio Info and Player */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-2">
                  <p className="text-sm font-medium text-gray-900 dark:text-white ">
                    {audio.name}
                  </p>
                  {audio.isConverting && (
                    <span className="text-xs text-purple-600 dark:text-purple-400">Converting to MP3...</span>
                  )}
                  {audio.isUploading && !audio.isConverting && (
                    <span className="text-xs text-blue-600 dark:text-blue-400">Uploading...</span>
                  )}
                  {audio.uploadFailed && (
                    <span className="text-xs text-red-600 dark:text-red-400">Failed</span>
                  )}
                </div>

                {/* Custom Audio Player */}
                <CustomAudioPlayer
                  audioUrl={audio.url}
                  audioId={audio.id}
                  duration={audio.duration}
                  isUploading={audio.isUploading}
                  onStop={() => { }}
                  onDelete={() => onDeleteRecording(audio.id)}
                />

                <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">
                  {audio.timestamp}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default VoiceRecordingsList

